export default __webpack_public_path__ + "static/media/img_post3.ad1a7a66.png";